var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-overlay',[_c('v-card',[_c('v-card-title',[_vm._v(" Critical error! ")]),_c('v-card-text',[_vm._v(" A critical error occured. Please reload the page to try again. ")]),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.reload}},[_vm._v(" Reload ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }